<template lang="pug">
    div(class="_snackbar")
        TransitionGroup(name="fade-05")
            div(v-for="msg in rows", class="_msg _ns", :class="'bg70-'+(msg[0]||'gray')", :key="msg[2]")
                div(class="text", v-html="format(msg[1])")
                ib-button(class="link _close", @click="dismiss(msg[2])")
                    include ../../icon/basic/close.svg
</template>

<script>
    import $markdown from '../../prototype/markdown'

    /**
     * DEPRECATED.
     */
    export default {
        name: 'ib-snackbar',

        data() {
            return {
                rows: [],
                id: 0
            };
        },

        created() {
            let self = this;
            window.$notify = function(msg, duration, type) {
                self.notify(msg, duration || 5, type);
            };
            window.$notifySuccess = function(msg, duration) {
                self.notify(msg, duration || 5, 'positive');
            };
            window.$notifyError = function(msg, duration) {
                self.notify(msg, duration || 8, 'negative');
            };
        },

        methods: {
            notify(msg, duration, type) {
                let self = this;
                let id = self.id++;
                self.rows.push([type, msg, id]);
                setTimeout(function() {
                    self.dismiss(id);
                }, duration * 1000);
            },

            format(msg) {
                if (typeof msg === "string") {
                    return msg;
                } else {
                    return $markdown.toHTML(msg[0]).replace(/(^|[^\\])\$(\d)/g, (all,pre,index) => (pre+msg[+index]));
                }
            },

            dismiss(id) {
                this.rows = this.rows.filter(e => e[2] != id);
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._snackbar {
        position: absolute;
        left: 0;
        right: 0;
        cursor: default;

        ._msg {
            position: relative;
            text-align: center;
            text-shadow: 1px 1px 1px rgba(0,0,0,.2);
            line-height: 24px;
            box-shadow: inset 0 16px 16px -16px #000;
            -webkit-backdrop-filter: blur(2px);
                    backdrop-filter: blur(2px);

            .text {
                width: calc(~'100% - 24px');
                white-space: nowrap;
                overflow: hidden;
            }
            ._close {
                position: absolute;
                top: 0;
                right: 8px;
            }
        }
    }
</style>

<docs>
    Basic Example:
    ```jsx
        new Vue({
            data() {
                return {
                    val: 5
                }
            },
            methods: {
                toggleSnack() {
                    this.$refs.snackbar.notify("Hello World", 10000, 'accent')
                }
            },
            template: `
                <div>
                    <ib-button @click="toggleSnack"> Toggle Snacks</ib-button>
                    <ib-snackbar ref="snackbar" />
                </div>
            `
        });
    ```
</docs>
